import styled, { css } from 'styled-components';
import { Button, Layout, LayoutProps, SiderProps } from 'antd';
import { DynamicObjectType } from 'core/types/common';

export interface CustomLayoutProps extends LayoutProps {
  children?: React.ReactNode;
  customCreateBtn?: React.ReactNode;
  isCreateModal?: boolean;
  title?: string;
  customRootPath?: string;
  hiddenCreateButton?: boolean;
  isFull?: boolean;
  checkRoles?: DynamicObjectType;
}

export interface CustomSiderProps extends SiderProps {
  children?: React.ReactNode;
}

const PrivateLayoutWrapper = styled(Layout)<CustomLayoutProps>`
  height: 100vh;
  width: 100vw;
  .layout-content {
    padding: 24px;
    overflow-y: auto;
    height: calc(100vh - 85px);

    &-wrap {
      max-width: 1280px;
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export const SidebarWrapper = styled(Layout.Sider)<CustomSiderProps>`
position; relative;
max-height:100vh;
.ant-layout-sider-children {
  display: flex !important;
  flex-direction:column  !important;
}
border-right: 1px solid var(--border-color);
.logo-vertical {
  height: 58px;
  display: flex;
  align-items:center;
  justify-content:space-between;
  padding: 0 22px;
  position: relative;

  ${({ collapsed }) =>
    collapsed &&
    css`
      justify-content: center;
      margin-bottom: 12px;
    `}
}
.collapsed-icon {
  font-size: 12px;
  color: var(--primary);
  padding: 3px 4px;
  border: 1px solid #EDEEF2;
  border-radius: 3px;
}
.btn-collapsed {
  border: none;
  background-color: transparent;
  min-width: max-content;
  width: max-content;
  height: max-content;
  padding: 0;
  line-height: normal;

  ${({ collapsed }) =>
    collapsed &&
    css`
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
    `}
}
.ant-menu-item-icon {
    ${({ collapsed }) =>
      collapsed &&
      css`
        width: 100% !important;
        text-align: center !important;
      `}
}
.sidebar-menu {
  flex:1;
  padding: 0 10px;
}
.ant-menu {
  border-inline-end: 0 !important;

  &-item {
    width: 100%;
    height: 39px;
    line-height: 39px;
    margin-inline: 0 !important;

    ${({ collapsed }) =>
      collapsed &&
      css`
        width: auto;
      `}
  }
}
.ant-menu-submenu {
  &-title {
    width: 100%;
    height: 39px !important;
    line-height: 39px !important;
    margin-inline: 0 !important;

    ${({ collapsed }) =>
      collapsed &&
      css`
        width: auto;
      `}
  }

  &-arrow {
    color: #B6B8C1;
  }
}
.menu-icon-wrap {
  width: 24px;
  min-width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ant-menu-title-content {
  font-size: 14px;
  font-weight: 400;
  color: #53575D;
}
.ant-menu-item-selected,
.ant-menu-submenu-selected {
  background-color: #F0EEFB;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 5px;
    transform: translateY(-50%);
    width: 3px;
    height: 26px;
    border-radius: 5px;
    background: var(--primary);
    display: block;
  }

  .menu-icon-wrap {
    svg {
      color: var(--primary);
    }
  }
  .ant-menu-title-content {
    font-size: 14px;
    font-weight: 600;
    color: var(--primary);
  }
}
`;

export const HeaderWrapper = styled(Layout.Header)<CustomLayoutProps>`
  padding-inline: 20px !important;
  padding-left: 30px !important;
  height: 50px;
  line-height: 50px;

  .main-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
  }
  .page-title {
    font-weight: 600;
    font-size: 16px;
  }
  .ant-input-affix-wrapper {
    border: none;
  }
`;

export const CreateButtonStyles = styled(Button)`
  border-radius: 7px;
  font-weight: 500;
  font-size: 12px;
  height: 32px;
  line-height: normal;
  padding: 4px 15px;
  display: flex;
  align-items: center;
  gap: 4px;

  svg {
    font-size: 9px;
  }
`;

export default PrivateLayoutWrapper;
